import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { get, size } from 'lodash/fp';
import dayjs from 'dayjs';
import { TextField } from '../../common/components';

const areEqual = (prevProps, nextProps) => {
  if (
    prevProps.field.value === nextProps.field.value
    && prevProps.field.name === nextProps.field.name
    && prevProps.form.dirty === nextProps.form.dirty
    && prevProps.form.errors[prevProps.field.name] === nextProps.form.errors[nextProps.field.name]
    && prevProps.form.touched[prevProps.field.name] === nextProps.form.touched[nextProps.field.name]
  ) {
    return true;
  }

  return false;
};

const S = {
  TextField: styled(TextField)`
    width: 65px;
    margin: 0 0.5rem;
    .input {
      padding: 0 0.25rem;
      text-align: right;
    }
  `,
};

const YearField = React.memo(({ field: { onChange, ...field }, form, ...otherProps }) => {
  const handleChange = useCallback((event) => {
    if (/^\d+$/.test(event.target.value) && size(event.target.value) === 4) {
      onChange(event);
    }
  }, [onChange]);

  return (
    <S.TextField
      {...field}
      {...otherProps}
      onChange={handleChange}
      inputProps={{
        type: 'number',
        max: dayjs().year() + 1,
        min: dayjs().year() - 1,
      }}
      error={!!(get(field.name, form.errors) && get(field.name, form.touched))}
    />
  );
}, areEqual);

YearField.propTypes = {
  field: PropTypes.shape({
    name: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
      PropTypes.shape({}),
    ]).isRequired,
    onBlur: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
  }).isRequired,
  form: PropTypes.shape({
    errors: PropTypes.shape({
      number: PropTypes.shape({
        year: PropTypes.string,
      }),
    }).isRequired,
    touched: PropTypes.shape({
      number: PropTypes.shape({
        year: PropTypes.bool,
      }),
    }).isRequired,
  }).isRequired,
};

export default YearField;
